import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { closingStatement } from '../data/mock';

const CTASection = () => {
  return (
    <section
      className="py-24 px-6 relative overflow-hidden"
      style={{ background: 'var(--bg-section)' }}
      id="cta"
    >
      {/* Background glow */}
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-20 pointer-events-none"
        style={{ background: 'radial-gradient(circle, var(--accent-primary) 0%, transparent 70%)' }}
      />
      
      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="heading-1 mb-6">{closingStatement.title}</h2>
          <p className="body-large mb-4">
            {closingStatement.description}
          </p>
          <p
            className="caption mb-10"
            style={{ color: 'var(--accent-primary)' }}
          >
            {closingStatement.tagline}
          </p>
          <a href="#contact" className="btn-primary">
            Get in Touch
            <ArrowRight size={18} />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
